export default __webpack_public_path__ + "static/media/bg20.936f5199.jpg";